import { useEffect, useRef, useState } from "react";

const FlechaDominante = ({ rotation, radius = 35, speed = 0.25, offset = 20 }) => {
  const [distance, setDistance] = useState(0);
  const requestRef = useRef();

  useEffect(() => {
    const animate = () => {
      setDistance((prev) => {
        const next = prev + speed;
        if (next > radius) return 0;
        return next;
      });
      requestRef.current = requestAnimationFrame(animate);
    };
    requestRef.current = requestAnimationFrame(animate);
    return () => cancelAnimationFrame(requestRef.current);
  }, [radius, speed]);

  // Componente flecha genérico
  const Arrow = ({ shorter = false }) => (
    <svg
      width="40"
      height={shorter ? 60 : 80}
      viewBox={shorter ? "0 0 24 60" : "0 0 24 80"}
      style={{
        position: "absolute",
        top: "0",
        left: "0",
        transform: "translate(-50%, -100%)",
        transformOrigin: "bottom center",
      }}
    >
      <path
        d={
          shorter
            ? "M12 0 L16 10 H8 L12 0 Z M10 10 H14 V50 H10 V10 Z" // más corta
            : "M12 0 L18 12 H6 L12 0 Z M10 10 H14 V80 H10 V10 Z" // completa
        }
        fill="#0080ff"
      />
    </svg>
  );

  return (
    <>
      {/* Flecha central */}
      <div
        style={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: `rotate(${rotation}deg) translateY(-${distance}px)`,
          transformOrigin: "center",
          pointerEvents: "none",
        }}
      >
        <Arrow />
      </div>

      {/* Flecha izquierda */}
      <div
        style={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: `rotate(${rotation}deg) translateX(-${offset}px) translateY(-${distance}px)`,
          transformOrigin: "center",
          pointerEvents: "none",
        }}
      >
        <Arrow shorter />
      </div>

      {/* Flecha derecha */}
      <div
        style={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: `rotate(${rotation}deg) translateX(${offset}px) translateY(-${distance}px)`,
          transformOrigin: "center",
          pointerEvents: "none",
        }}
      >
        <Arrow shorter />
      </div>
    </>
  );
};

export default FlechaDominante;
